import type { PortalConfig } from '@shared/config';

export const lexlabourConfig: PortalConfig = {
  id: 'lexlabour',

  // LexLabour shows only arbeidsrecht cases
  includePortals: ['lexlabour'],

  branding: {
    name: 'LexLabour',
    tagline: 'De exclusieve database voor arbeidsrechtadvocaten',
    rechtsgebiedNaam: 'arbeidsrecht',
    rechtsgebiedBeschrijving: 'Dagelijkse nieuwsbrief met hoogwaardige samenvattingen van uitspraken van die dag en intelligente zoekmachine om juiste jurisprudentie te vinden.',
    contactEmail: 'info@lexlabour.nl',
    contactFormRecipient: 'remco.volmer@riverwise.nl',
    linkedInUrl: 'https://www.linkedin.com/company/lexlabour',
    domain: 'lexlabour.nl',
  },

  colors: {
    primary: 'oklch(0.68 0.12 75)',
    primaryHover: 'oklch(0.60 0.11 75)',
    secondary: 'oklch(0.27 0.055 255)',
    themeColor: '#bf9139',
  },

  assets: {
    logo: '/lexlabour_logo.svg',
    logoSmall: '/lexlabour_logo_small.svg',
    logoHeight: 'h-9', // Smaller height for square viewBox logo
  },

  storage: {
    themeKey: 'lexlabour-theme',
    searchStoreKey: 'lexlabour-search',
  },

  newsletter: {
    dailySendTime: '17:30',
    weeklySendDay: 'vrijdag',
    weeklySendTime: '11:30',
  },

  partnership: {
    label: 'LexLabour is een samenwerking van Riverwise en Pascal-AI',
    partners: [
      { name: 'Riverwise', logo: '/riverwise_logo.png', url: 'https://riverwise.nl' },
      { name: 'Pascal-AI', logo: '/pascal_ai_logo.png', logoHeight: 'h-7', url: 'https://pascal-ai.nl' },
    ],
  },

  scraper: {
    rechtsgebiedUri: 'http://psi.rechtspraak.nl/rechtsgebied#civielRecht_arbeidsrecht',
  },
};
